(() => {
  const modal = document.getElementById('ProcessingTimeConsent');
  if (!modal) return;

  const checkbox = modal.querySelector('[data-processing-consent-checkbox]');
  const confirmButton = modal.querySelector('[data-processing-consent-confirm]');
  const error = modal.querySelector('[data-processing-consent-error]');
  const closeButtons = modal.querySelectorAll('[data-processing-consent-close]');
  const dialog = modal.querySelector('.processing-consent__dialog');
  const allowedSubmissions = new WeakSet();

  let pendingForm = null;
  let pendingSubmitter = null;
  let triggerElement = null;

  const openModal = (form, submitter) => {
    pendingForm = form;
    pendingSubmitter = submitter || form.querySelector('[name="add"]');
    triggerElement = pendingSubmitter || document.activeElement;
    checkbox.checked = false;
    confirmButton.disabled = true;
    error.hidden = true;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('processing-consent-open');
    window.requestAnimationFrame(() => checkbox.focus());
  };

  const closeModal = () => {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('processing-consent-open');
    pendingForm = null;
    pendingSubmitter = null;
    if (triggerElement && typeof triggerElement.focus === 'function') {
      triggerElement.focus();
    }
    triggerElement = null;
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[action*="/cart/add"]')) return;
      if (allowedSubmissions.has(form)) {
        allowedSubmissions.delete(form);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      openModal(form, event.submitter);
    },
    true
  );

  checkbox.addEventListener('change', () => {
    confirmButton.disabled = !checkbox.checked;
    error.hidden = checkbox.checked;
  });

  confirmButton.addEventListener('click', () => {
    if (!checkbox.checked) {
      error.hidden = false;
      checkbox.focus();
      return;
    }

    const form = pendingForm;
    const submitter = pendingSubmitter;
    if (!form) return;

    allowedSubmissions.add(form);
    closeModal();

    if (typeof form.requestSubmit === 'function') {
      if (submitter) {
        form.requestSubmit(submitter);
      } else {
        form.requestSubmit();
      }
    } else if (submitter) {
      submitter.click();
    } else {
      form.submit();
    }
  });

  closeButtons.forEach((button) => button.addEventListener('click', closeModal));

  document.addEventListener('keydown', (event) => {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key === 'Tab') {
      const focusable = Array.from(
        dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')
      );
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
